export const environment = {
    production: false,
    host: "mmr2nmjkw3.execute-api.us-east-1.amazonaws.com",
    security: "https://",
    version: "/v1/",
    typeService: "rest/backoffice/",
    envName: 'DEV',
    encryptionSecret: "AAAAAAAAAAAAAAAA",
    xApiKey: "5VjmIazerUb1VvMQLjTG3v7wDvms0xG86TZXpeq8",
    accessKeyEmpty: "",
    mslConfig: {
        clientId: "9f2fbb10-9d22-4758-9ed6-c12aebddef6e",
        authority: "https://login.microsoftonline.com/49624d69-0e6c-462c-8734-37407d3d1e54",
        redirectUri: 'https://d1mp79ybkewh2h.cloudfront.net'
    },
    scope: "api://001918d5-d1a6-45dd-81c8-94d9102435ee/Onboarding.ReadWrite"
};
